<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive include="HomeView,MenuAcoesView,MenuNoticiasView">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <ToastNotification />
  </div>
</template>

<script setup>
import ToastNotification from "@/components/common/ToastNotification.vue";
</script>

<style></style>
